/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamPracticeEnsureResponseBookingId } from './oralExamPracticeEnsureResponseBookingId';
import type { OralExamPracticeEnsureResponseSlotId } from './oralExamPracticeEnsureResponseSlotId';

/**
 * Ids to open the student dry-run live session.
 */
export interface OralExamPracticeEnsureResponse {
  courseId: string;
  moduleId: string;
  taskId: string;
  sessionId: string;
  bookingId?: OralExamPracticeEnsureResponseBookingId;
  slotId?: OralExamPracticeEnsureResponseSlotId;
}
